module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./DetailView.js"));
	}, "OrderDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OrderDetailView!./src/pages/Shop/Member/TradeManage/OrderList/Detail/DetailView.js
// module id = 1525
// module chunks = 418